import { DraftConfiguration, Rect } from '@/types';
import { getRotatedRect } from '@/utils/math/getRotatedRect';
import { getCurrentSizeOfConfiguration } from './getCurrentSizeOfConfiguration';

export const getBoundingBoxesForConfigurations = (configurations: DraftConfiguration[]) => {
  const result: Record<number, Rect> = {};
  for (const configuration of configurations) {
    result[configuration.cid] = getBoundingBoxForConfiguration(configuration);
  }
  return result;
};

export const getBoundingBoxForConfiguration = (configuration: DraftConfiguration) => {
  const {
    offset: { x, y },
  } = configuration;
  const { width, height } = getCurrentSizeOfConfiguration(configuration);
  return getRotatedRect(configuration.rotation, { x, y, width, height });
};
